import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface OtherIncomeInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function OtherIncomeInternalControls({ onBack, setActiveSection, controlsListSection }: OtherIncomeInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Other Income"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}


